import {MsalService} from "@azure/msal-angular";
import { ApiService } from "../services/api.service";
import { DelegacionService } from "../services/bd/Delegacion/delegacion.service";
import { ApiDiasTaller } from "./ApiHorasTaller";
import { ValidacionFecha } from "./ValidacionFecha";
import { Observable } from "rxjs";
export class AnexoDelegacion
{
  delegacion: any;
  email: string = '';
  nombre: string = '';
  razon_social: string = '';
  tipo: string = '';
  provincia: string = '';
  poblacion: string = '';
  cp: string = '';
  direccion: string = '';
  telefono: string = '';
  gerente: string = '';
  del_operativo: string = '';
  comercial: string = '';
  incidencia_albaranes: string = '';
  peticion_rls: string = '';
  incidencias_rls: string = '';
  aperturas_hojas_trabajo_cc: string = '';
  incidencias_almacen: string = '';
  cliente_credito_contado: string = '';
  horario_apertura_mañanas: string = '';
  horario_cierre_mañanas: string = '';
  horario_apertura_tardes: string = '';
  horario_cierre_tardes: string = '';
  horario_apertura_sabados: string = '';
  horario_cierre_sabados: string = '';
  latitud: string = '';
  longitud: string = '';
  comunidad: string = '';
  cif: string = '';
  codigo_cliente: string = '';
  umc_calibracion: string = '';
  ip_taller: string = '';
  ciudad_id: number = 0;
  fecha_baja: string = '';
  usuario_baja: string = '';
  maquina_ozono: string = '';
  adas_calibracion: string = '';
  active: number = 0;
  camiones_en_taller: string = '';
  unidad_movil: string = '';
  observaciones: string = '';
  maps: string = '';
  descripcion: string = '';
  cabe_vi: string = '';
  alarma: string = '';
  um_taller: string = '';
  anydesk: string = '';
  cierre_ruta: string = '';
  hora_de_carga: string = '';
  zona_taller: string = '';
  telefono2: string = '';
  en_web: string = '';
  web_margen_peticion: string = '';
  web_margen_horario: string = '';
  nombre_web: string = '';
  descripcion_web: string = '';
  token:string="";
  booking: boolean  = false;

  constructor(private delegacionService:DelegacionService,private msalService: MsalService,data?: any, delegacion? :string, nombre?: string)
  {
    if (data == null){
      if(delegacion != null && nombre != null){
        this.delegacion = delegacion;
        this.nombre = nombre;
      }
    }else{
      this.delegacion = data.delegacion;
      this.email = data.email.trim();
      this.nombre = data.nombre.trim();
      this.razon_social = data.razon_social.trim();
      this.tipo = data.tipo.trim();
      this.provincia = data.provincia.trim();
      this.poblacion = data.poblacion.trim();
      this.cp = data.cp.trim();
      this.direccion = data.direccion.trim();
      this.telefono = data.telefono.trim();
      this.gerente = data.gerente.trim();
      this.del_operativo = data.del_operativo.trim();
      this.comercial = data.comercial.trim();
      this.incidencia_albaranes = data.incidencia_albaranes.trim();
      this.peticion_rls = data.peticion_rls.trim();
      this.incidencias_rls = data.incidencias_rls.trim();
      this.aperturas_hojas_trabajo_cc = data.aperturas_hojas_trabajo_cc.trim();
      this.incidencias_almacen = data.incidencias_almacen.trim();
      this.cliente_credito_contado = data.cliente_credito_contado.trim();
      this.horario_apertura_mañanas = data.horario_apertura_mañanas.trim();
      this.horario_cierre_mañanas = data.horario_cierre_mañanas.trim();
      this.horario_apertura_tardes = data.horario_apertura_tardes.trim();
      this.horario_cierre_tardes = data.horario_cierre_tardes.trim();
      this.horario_apertura_sabados = data.horario_apertura_sabados.trim();
      this.horario_cierre_sabados = data.horario_cierre_sabados.trim();
      this.latitud = data.latitud.trim();
      this.longitud = data.longitud.trim();
      this.comunidad = data.comunidad.trim();
      this.cif = data.cif.trim();
      this.codigo_cliente = data.codigo_cliente.trim();
      this.umc_calibracion = data.umc_calibracion.trim();
      this.ip_taller = data.ip_taller.trim();
      this.ciudad_id = data.ciudad_id;
      this.fecha_baja = data.fecha_baja.trim();
      this.usuario_baja = data.usuario_baja.trim();
      this.maquina_ozono = data.maquina_ozono.trim();
      this.adas_calibracion = data.adas_calibracion.trim();
      this.active = data.active;
      this.camiones_en_taller = data.camiones_en_taller.trim();
      this.unidad_movil = data.unidad_movil.trim();
      this.observaciones = data.observaciones.trim();
      this.maps = data.maps.trim();
      this.descripcion = data.descripcion.trim();
      this.cabe_vi = data.cabe_vi.trim();
      this.alarma = data.alarma.trim();
      this.um_taller = data.um_taller.trim();
      this.anydesk = data.anydesk.trim();
      this.cierre_ruta = data.cierre_ruta.trim();
      this.hora_de_carga = data.hora_de_carga.trim();
      this.zona_taller = data.zona_taller.trim();
      this.telefono2 = data.telefono2.trim();
      this.en_web = data.en_web.trim();
      this.web_margen_peticion = data.web_margen_peticion.trim();
      this.web_margen_horario = data.web_margen_horario.trim();
      this.nombre_web = data.nombre_web.trim();
      this.descripcion_web = data.descripcion_web.trim();
      this.booking = data.booking.trim();
    }
  }


  //Devuelve los festivos del taller
  //public getDiasTaller(taller:number,apiService:ApiService)
  public getDiasTaller(apiService:ApiService):Promise<string[]> {
    let fechaParseada = ValidacionFecha.formatearFecha(new Date());
    return apiService.getDiasFestivosTaller(parseInt(this.delegacion), fechaParseada)
      .then(res => {
        return res.message;
      })
      .catch(error => {
        console.error(error);
        return [];
      });
  }

  getAvisoTallerText(apiService: ApiService): Promise<string>
  {
    let festivos: string[] = [];
    let horarios: string[] = [];
    let avisosTaller: string = "";

    return new Promise<string>((resolve, reject) => {
      this.getDiasTaller(apiService)
        .then(res => {
          festivos = res;
          horarios = [
            "Horario de mañana: " + (this.horario_apertura_mañanas.trim() ?? '') + " - " + (this.horario_cierre_mañanas.trim() ?? ''),
            "Horario de tarde: " + (this.horario_apertura_tardes.trim() ?? '') + " - " + (this.horario_cierre_tardes.trim() ?? ''),
            this.horario_apertura_sabados.toUpperCase().includes("CERRADO")
              ? "Horario de sábado: CERRADO"
              : "Horario de sábado: " + (this.horario_apertura_sabados.trim() ?? '') + " - " + (this.horario_cierre_sabados.trim() ?? ''),
            "FESTIVOS:"
          ];

          festivos.forEach(festivo => { horarios.push(festivo); });

          avisosTaller = horarios.join('\n');
          resolve(avisosTaller); // Resolve the Promise with the value of avisosTaller
        })
        .catch(error => {
          console.error(error);
          reject(error); // Reject the Promise if there was an error
        });
    });

  }
  //Recoge desde BD los datos que faltan y se asignan
  recargarDatos()
  {
    this.getAccessTokenPromise().finally(()=>
    {
      this.delegacionService.getDatosDelegacion(this.token,this.delegacion)
      .then(nDelegacion=>
      {
        Object.assign(this, nDelegacion);
      })
    });
  }

  //recogemos el token.
  //Lo hacemos asi para que espere a que termine de recoger el token para
  //hacer el resto de llamadas al controlador
  private getAccessTokenPromise():Promise<void>
  {
    return new Promise((resolve, reject) => {
      this.msalService.acquireTokenSilent({ scopes: ['GroupMember.Read.All'] }).subscribe(
        resultado => {
          this.token = resultado.accessToken;
          // call the method that depends on the access token here
          resolve();
        },
        error => {
          // handle error here
          reject(error);
        }
      );
    });
  }
}
